<template>
  <div>
    <page-header :title="$t('scope.text_297')" />
    <page-body>
      <exchange-rate-manager-list :id="listId" :getParams="getParams" />
    </page-body>
  </div>
</template>

<script>
import ExchangeRateManagerList from './components/List'

export default {
  name: 'ExchangeRateManagerIndex',
  components: {
    ExchangeRateManagerList,
  },
  data () {
    return {
      listId: 'ExchangeRateManagerList',
      getParams: {
        details: true,
      },
    }
  },
}
</script>
